import React from 'react';

import { BsFillCheckCircleFill } from 'react-icons/bs';
import { PiCaretRightBold } from 'react-icons/pi';

import { useRouter } from 'next/router';

import FormSteps from '@/components/FormSteps';
import StickyPhoneBubble from '@/components/StickyPhoneBubble';

import { SUBCATEGORY_NEEDS } from '@/contexts/subcategory_needs';

const NeedIdSelect = ({ category = {} }) => {
  const [error, setError] = React.useState(false);
  const [selectedService, setSelectedService] = React.useState({});

  const serviceOptions = SUBCATEGORY_NEEDS[category.name];

  const router = useRouter();

  React.useEffect(() => {
    if (window.innerWidth <= 480 && selectedService.need_id) {
      router.push(`/cf/${category.url_slug}/${selectedService.need_id.indexOf('service') > -1 ? 'service' : selectedService.need_id}`);
    }
  }, [category.url_slug, router, selectedService.need_id]);

  const getHeadlineLabel = () => {
    const vowels = ['a', 'e', 'i', 'o', 'u'];

    const label = category.name_adjective || '';

    if (vowels.indexOf(label.toLowerCase().substr(0, 1)) > -1) {
      return `an ${category.name_adjective}`;
    }
    return `a ${category.name_adjective}`;
  };

  const handleSelect = (serviceOption) => {
    setError(false);

    setSelectedService(serviceOption);
  };

  const validate = () => {
    if (!selectedService.need_id) {
      setError(true);
    } else {
      router.push(`/cf/${category.url_slug}/${selectedService.need_id.indexOf('service') > -1 ? 'service' : selectedService.need_id}`);
    }
  };

  return (
    <div className="lead-flow-form-container">
      <div className="lead-flow-wrapper">
        <FormSteps stepIndex={1} totalSteps={7} />
        {!serviceOptions && <h1>Loading Services...</h1>}
        {serviceOptions && (
          <>
            <h1>Select {getHeadlineLabel()} Service.</h1>
            <fieldset className="panel-content">
              <div className="row">
                <div className={`input-container radio-container ${error ? 'error' : ''}`}>
                  {serviceOptions.map((serviceOption) => (
                    <button key={serviceOption.need_id} className={`radio button ${selectedService.need_id === serviceOption.need_id ? 'selected' : ''}`} onClick={() => handleSelect(serviceOption)}>
                      {selectedService.need_id === serviceOption.need_id && <BsFillCheckCircleFill />}
                      {serviceOption.label}
                      <div className="caret mobile">
                        <PiCaretRightBold />
                      </div>
                    </button>
                  ))}
                </div>
              </div>
              <div className="error_msg">{error ? 'Please select a service.' : <span>&nbsp;</span>}</div>
              <div className="row next-container">
                <div className="actions">
                  <button className="next button" onClick={validate}>
                    Next
                  </button>
                </div>
              </div>
            </fieldset>
          </>
        )}
      </div>
      <StickyPhoneBubble category={category} />
    </div>
  );
};

export default NeedIdSelect;
